import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ef4b8f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "top_header",
  style: {"height":"100vh"}
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "footer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Confirmation de dénonciation", -1))
const _hoisted_5 = { class: "contexte" }
const _hoisted_6 = { class: "all" }
const _hoisted_7 = { class: "follow" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderPage = _resolveComponent("HeaderPage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HeaderPage),
      _createElementVNode("footer", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(" Votre demande a été enregistrée avec succès."),
              _hoisted_8,
              _hoisted_9,
              _createTextVNode(" Son numéro de suivie est : " + _toDisplayString(_ctx.ps), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}